import React from 'react';
import { NavLink, Outlet, Navigate, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import {
  LayoutDashboard, Package, ServerCog, HelpCircle, FileText, GitCommit, Layers, Gift,
  MessageSquare, Users, Mail as MailIcon, Settings, LogOut, ExternalLink, Image, Ticket, Menu as MenuIcon,
  Globe2, Grid, LayoutTemplate, Award, Smartphone, Gamepad2, ShieldCheck
} from 'lucide-react';

const nav = [
  { to: '/admin', end: true, label: 'Dashboard', icon: LayoutDashboard },
  { section: 'İÇERİK' },
  { to: '/admin/products', label: 'Ürünler', icon: Package },
  { to: '/admin/categories', label: 'Kategoriler', icon: Layers },
  { to: '/admin/servers', label: 'Sunucular (Hosting/VPS)', icon: ServerCog },
  { to: '/admin/test_servers', label: 'Test Sunucuları', icon: Gamepad2 },
  { to: '/admin/free_products', label: 'Ücretsiz Ürünler', icon: Gift },
  { to: '/admin/project_updates', label: 'Güncellemeler', icon: GitCommit },
  { to: '/admin/projects', label: 'Projeler', icon: Layers },
  { to: '/admin/mobile_apps', label: 'Mobil Uygulamalar', icon: Smartphone },
  { to: '/admin/pages', label: 'Sayfalar', icon: LayoutTemplate },
  { to: '/admin/faqs', label: 'SSS', icon: HelpCircle },
  { to: '/admin/testimonials', label: 'Müşteri Yorumları', icon: MessageSquare },
  { to: '/admin/references', label: 'Referanslarımız', icon: Award },
  { to: '/admin/galleries', label: 'Galeri', icon: Image },
  { to: '/admin/blog_posts', label: 'Blog', icon: FileText },
  { to: '/admin/blog_categories', label: 'Blog Kategorileri', icon: Grid },
  { to: '/admin/menus', label: 'Menüler', icon: MenuIcon },
  { section: 'MÜSTERİ' },
  { to: '/admin/users', label: 'Kullanıcılar', icon: Users },
  { to: '/admin/orders', label: 'Siparişler', icon: Package },
  { to: '/admin/coupons', label: 'Kuponlar', icon: Ticket },
  { to: '/admin/contact_messages', label: 'Mesajlar', icon: MessageSquare },
  { to: '/admin/mailing_list', label: 'Bülten', icon: MailIcon },
  { section: 'SİSTEM' },
  { to: '/admin/media', label: 'Medya', icon: Image },
  { to: '/admin/languages', label: 'Diller', icon: Globe2 },
  { to: '/admin/translations', label: 'Metin Çevirileri', icon: FileText },
  { to: '/admin/email_templates', label: 'E-posta Şablonları', icon: MailIcon },
  { to: '/admin/settings', label: 'Ayarlar', icon: Settings },
];

export default function AdminLayout() {
  const { admin, loading, logout } = useAdminAuth();
  const nvg = useNavigate();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#08080b] text-white/60">Yükleniyor...</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#08080b] text-white flex">
      <aside className="w-64 shrink-0 border-r border-white/8 bg-[#0a0a0f] flex flex-col h-screen sticky top-0">
        <div className="px-5 py-5 border-b border-white/8">
          <div className="font-display font-black text-lg">AEGIS <span className="gold-text">ADMIN</span></div>
          <div className="text-[11px] text-white/40 truncate">{admin.email}</div>
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-2 text-sm space-y-0.5">
          {nav.map((n, i) => {
            if (n.section) return <div key={i} className="px-3 pt-4 pb-1 text-[10px] font-bold tracking-widest text-[#e4b44e]/60">{n.section}</div>;
            return (
              <NavLink key={n.to} to={n.to} end={n.end}
                className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2 rounded-lg transition ${isActive ? 'bg-[#e4b44e]/15 text-[#f4d896]' : 'text-white/65 hover:text-white hover:bg-white/5'}`}>
                <n.icon className="w-4 h-4" /> {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-white/8 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-white/65 hover:text-white hover:bg-white/5"><ExternalLink className="w-4 h-4" /> Siteyi Gör</a>
          <button onClick={() => { logout(); nvg('/admin/login'); }} className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-white/65 hover:text-white hover:bg-red-500/10"><LogOut className="w-4 h-4" /> Çıkış</button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 md:p-10"><Outlet /></main>
    </div>
  );
}
